import { render, staticRenderFns } from "./ExperimentInfo.vue?vue&type=template&id=b0656e5e&scoped=true"
import script from "./ExperimentInfo.vue?vue&type=script&lang=js"
export * from "./ExperimentInfo.vue?vue&type=script&lang=js"
import style0 from "./ExperimentInfo.vue?vue&type=style&index=0&id=b0656e5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0656e5e",
  null
  
)

export default component.exports